import React from "react";
import "./NewCustomer.css";

const NewCustomer = () => (
  <section id="newCustomer" className="newCustomer-container">
    <div className="newCustomer-background"></div>
      <div className="text-box">
        <h3>Thank you for your interest in Splash</h3>
        <p>
        Our products may only be bought wholesale by approved retailers. Interested in becoming a retailer? Apply today to view our entire product line and to get access to wholesale pricing!
        </p>
        <a href="http://splash.remotecatalog.com/getNewClient.php">Apply Now</a>
      </div>
  </section>
);

export default NewCustomer;
